import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";
import {AUTH_TIPE} from "../constants/AuthConstant";

const  shiftJadwalService = {}

shiftJadwalService.data = function (token,data='') {
    return fetch({
        url: '/transaksi/shift_jadwal/data',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

shiftJadwalService.data_import = function (token,data) {
    return fetch({
        url: '/transaksi/shift_jadwal/data_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

shiftJadwalService.empty_import = function (token,data) {
    return fetch({
        url: '/transaksi/shift_jadwal/empty_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

shiftJadwalService.save_import = function (token,data) {
    return fetch({
        url: '/transaksi/shift_jadwal/save_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}


export default shiftJadwalService;
